<template>
    <div>
        <div v-if="authUserPermission['material-type-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <div class="col-7">
                                <h3 class="mb-0">{{ tt('material_type') }}</h3>
                            </div>
                            <div class="col-5">
                                <div class="form-group">
                                    <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search_material_type')" v-on:keyup="filter"/>                            
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div>
                        <el-table height="350px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('client')" :prop="tt('client')" v-model="materialType.holding" min-width="128px" sortable>
                                <template v-slot="{row}">
                                    {{row.client_code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('code')" :prop="tt('code')" min-width="110px" sortable>
                                <template v-slot="{row}">
                                    {{row.code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('description')" :prop="tt('description')" v-model="materialType.description" min-width="205px" sortable>
                                <template v-slot="{row}">
                                    {{row.description}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('definition')" :prop="tt('definition')" v-model="materialType.definition" min-width="147px" sortable>
                                <template v-slot="{row}">
                                    {{row.definition}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('material_group')" :prop="tt('material_group')" v-model="materialType.material_group" min-width="385px" sortable>
                                <template v-slot="{row}">
                                    <span v-for="v in row.rel_mtype_mgroup">
                                        - {{v.material_group_code}}<br>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('maintenance_status')" :prop="tt('maintenance_status')" v-model="materialType.maintenance_status" min-width="222px" sortable>
                                <template v-slot="{row}">
                                    {{row.maintenance_status}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('account_category_refference')" :prop="tt('account_category_refference')" v-model="materialType.account_category_refference" min-width="307px" sortable>
                                <template v-slot="{row}">
                                    {{row.acc_cat_ref}} - {{row.acc_cat_ref_description}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('price_control')" :prop="tt('price_control')" v-model="materialType.price_control" min-width="197px" sortable>
                                <template v-slot="{row}">
                                    {{row.price_control_description}}
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="action" width="100">
                                <template v-slot="{row}">
                                    <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true">
                                        <span class="btn btn-sm btn-icon-only text-light">
                                            <i class="fas fa-ellipsis-v mt-2"></i>
                                        </span>
                                        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                            <el-dropdown-item :command="{action:'relation', data:row.code}">{{ tt('relation') }}</el-dropdown-item>                             
                                            <el-dropdown-item :command="{action:'edit', data:row.id}">{{ tt('edit') }}</el-dropdown-item>
                                            <el-dropdown-item :command="{action:'remove', data:row.id}">{{ tt('delete') }}</el-dropdown-item>                                        
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column> -->
                        </el-table>
                        <page-loading v-else/>
                    </div>
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="message in errorMessage.data">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>

                        <label class="form-control-label">{{ tt('holding') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('holding')" rules="required">
                            <el-select class="select-danger" v-model="materialType.client_code" :placeholder="tt('choose_holding')">
                                <el-option class="select-danger" :value="hc['client_code']" :label="hc['client_code'] + ' - ' + hc['client_name']" :key="hc['client_code'] + ' - ' + hc['client_name']" v-for="hc in  holdingCode"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('code') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('code')" :placeholder="tt('code')" v-model="materialType.code" rules="required|max:4"></base-input>

                        <label class="form-control-label">{{ tt('description') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('description')" :placeholder="tt('description')" v-model="materialType.description" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('definition') }}</label>
                        <base-input :name="tt('definition')" :placeholder="tt('definition')" v-model="materialType.definition"></base-input>

                        <label class="form-control-label">{{ tt('maintenance_status') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('maintenance_status')" :placeholder="tt('maintenance_status')" v-model="materialType.maintenance_status" rules="required|max:15"></base-input>

                        <label class="form-control-label">{{ tt('account_category_refference') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('account_category_refference')" rules="required">
                            <el-select class="select-danger" v-model="materialType.acc_cat_ref_code" :placeholder="tt('choose_account_category_refference')">
                                <el-option class="select-danger" :value="acr['acc_cat_ref']" :label="acr['acc_cat_ref'] + ' - ' + acr['acc_cat_ref_description']" :key="acr['acc_cat_ref'] + ' - ' + acr['acc_cat_ref_description']" v-for="acr in accountCategoryRefference"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('price_control') }}</label>
                        <base-input :name="tt('price_control')">
                            <el-select class="select-danger" v-model="materialType.price_control_code" :placeholder="tt('choose_price_control')">
                                <el-option class="select-danger" :value="pc['price_control_code']" :label="pc['price_control_code'] + ' - ' + pc['price_control_description']" :key="pc['price_control_code'] + ' - ' + pc['price_control_description']" v-for="pc in priceControl"></el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
            
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="formRelation.show">
                    <template slot="header">
                        <h5 class="modal-title">{{ tt('create_relation') }}</h5>
                    </template>
                    <div>
                        <div class="row">
                            <el-autocomplete
                            class="inline-input col-md-10"
                            v-model="dataRelation.material_group_code"
                            :fetch-suggestions="querySearch"
                            :placeholder="tt('choose_material_group')"
                            @select="handleSelect"
                            size="small"
                            ></el-autocomplete>
                            <base-button type="dark" size="sm" @click="addRelation">{{ tt('add') }}</base-button>
                        </div>
                        <br>
                        <table class="table table-sm table-hover" v-if="!onLoadRelation">
                            <tbody>
                                <tr v-for="(item, index) in materialGroup">
                                    <td>{{item.code}} - {{item.description}}<td>
                                    <td class="text-right"><i class="fa fa-trash text-danger" @click="deleteRelation(item.id)"></i></td>
                                </tr>
                            </tbody>
                        </table>
                        <page-loading v-else/>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="formRelation.show = false">{{ tt('close') }}</base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import materialType from '@/services/master/materialType.service';
    import holdingCode from '@/services/master/holdingCode.service';
    import accountCategoryRefference from '@/services/master/accountCategoryRefference.service';
    import priceControl from '@/services/master/priceControl.service';
    import materialGroup from '@/services/master/materialGroup.service';
    
    export default {
        data() {
            return {             
                onLoad: true,
                onLoadRelation: true,
                loadTimeout: null,  
                btnSave: {
                    onLoading: false
                },   
                links: [],
                dataRelation: {},
                form: {
                    add: true,
                    title: this.tt('add_material_type'),
                    show: false
                },      
                formRelation: {
                    show: false
                }, 
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                },     
                errorMessage: null,    
                materialType: {},
                holdingCode: {},
                accountCategoryRefference: {},
                priceControl: {},
                materialGroup: [],
                relationCode: null,
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
            this.getHoldingCode()
            this.getAccountCategoryRefference()
            this.getPriceControl()
            this.getMaterialGroup()
            this.links = this.materialGroup;
        },
        methods: {
            get() { 
                let context = this;               
                Api(context, materialType.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {    
                    context.table.total = response.data.data.data.total;
                    context.table.data = response.data.data.data.data; 
                    context.table.page  = response.data.data.data;  
                    context.onLoad = false;          
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad = false;
                    }
                })
                .call()
            },
            getHoldingCode() {
                let context = this;               
                Api(context, holdingCode.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.holdingCode = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.holdingCode = [];
                    }
                })
                .call()
            },
            getAccountCategoryRefference() {
                let context = this;               
                Api(context, accountCategoryRefference.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.accountCategoryRefference = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.accountCategoryRefference = [];
                    }
                })
                .call()
            },
            getPriceControl() {
                let context = this;               
                Api(context, priceControl.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.priceControl = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.priceControl = [];
                    }
                })
                .call()
            },
            getMaterialGroup() {
                let context = this;               
                Api(context, materialGroup.get({per_page: 'none'})).onSuccess(function(response) {    
                    response.data.data.data.data.forEach(function(item, index) {
                        context.materialGroup[index] = {
                            'code': item['code'],
                            'value': item['code'] + ' - ' + item['description']
                        };
                    });
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.materialGroup = [];
                    }
                })
                .call()
            },
            filter() {
                this.onLoad = true; 
                this.table.page.current_page = 1; 
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 1000);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'relation':
                            this.relation(command.data);
                        break;
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('add_catalog_status');
                this.form.show = true;
                this.materialType = {};
            },            
            edit(id) {
                this.errorMessage = null;
                let context = this;               
                Api(context, materialType.show(id)).onSuccess(function(response) {
                    context.materialType = response.data.data;
                    context.form.add = false;
                    context.form.title = context.tt('edit_catalog_status');
                    context.form.show = true;                          
                })
                .call()        
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, materialType.create(this.materialType));
                } else {{
                    api = Api(context, materialType.update(this.materialType.id, this.materialType));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, materialType.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
            getRelation(code) {
                let context = this;
                Api(context, materialType.material_group(code)).onSuccess(function(response) {
                    context.materialGroup = response.data.data;
                    context.onLoadRelation = false;
                }).call()
            },
            relation(code) { 
                this.onLoadRelation = true;
                this.relationCode = code;
                this.dataRelation.material_type_code = code;
                this.getRelation(code);
                this.formRelation.show = true;
            },
            addRelation() {
                let context = this;
                context.onLoadRelation = true;
                let fixDataRelation = {
                    'material_type_code': context.dataRelation.material_type_code,
                    'material_group_code': context.dataRelation.material_group_code.substr(0, context.dataRelation.material_group_code.search(' - '))
                };
                context.dataRelation.material_group_code = '';
                Api(context, materialType.add_relation(fixDataRelation)).onSuccess(function(response) {
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.getRelation(context.relationCode);
                })
                .call();
            },
            deleteRelation(id) {
                let context = this;
                context.onLoadRelation = true;
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, materialType.delete_relation(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.getRelation(context.relationCode);
                        }).call();
                    }
                })
            },
            reset() {
                this.materialType = {}
            },
            querySearch(queryString, cb) {
                var links = this.links;
                var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                // call callback function to return suggestions
                cb(results);
            },
            createFilter(queryString) {
                return (link) => {
                  return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            loadAll(materialGroup) {
                return materialGroup;
            },
            handleSelect(item) {
                // console.log(item);
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            }
        },
    };
</script>
<style></style>
